import { Component, inject, OnInit } from '@angular/core';
import { ApiEndpointsService } from './services/api-endpoints.service';
import { environment } from '@/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-shared-services';

@Component({
  selector: 'dr-flex-home-ui-root',
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  protected navbarUrl = inject(ApiEndpointsService).globalNavUrl;
  private translate = inject(TranslateService);
  private cookieService = inject(CookieService);

  ngOnInit(): void {
    const { defaults } = environment;
    const locale = this.cookieService.getI18NLocale() || defaults.locale;
    const brand = this.cookieService.getI18NBrand() || defaults.brand.toUpperCase();
    this.translate.setFallbackLang(`${defaults.locale}.${defaults.brand.toUpperCase()}`);
    this.translate.use(`${locale}.${brand}`);
  }
}
